// Module
var code = `<div class="js-level1-panel" style="{{>visibility}}" on-contextmenu="@this.onContextMenu(event)">
    <div class="js-table-container">
        {{#each Array(rowsCount):row}}
        <div class="js-table-container-row">
            {{#each Array(columnsCount):column}}
            {{#with level1ActveItems[row * columnsCount + column] as item}}
            <div class="js-table-container-column">
                <div class="js-title">{{item.label}}</div>
                <div class="js-value {{item.color}}">{{item.value}}</div>
            </div>
            {{/with}}
            {{/each}}
        </div>
        {{/each}}
    </div>
</div>
`;
// Exports
export default code;